import { topicItems } from '@/mocks/home';

export default function TopicsSection() {
  const getColorClasses = (color: string) => {
    if (color === 'primary') return 'bg-primary-100 text-primary-700 hover:bg-primary-200';
    if (color === 'accent') return 'bg-accent-100 text-accent-700 hover:bg-accent-200';
    return 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200';
  };

  return (
    <section id="topics" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-background-200 text-foreground-600 text-xs font-medium rounded-full mb-4">
            热门话题
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
            话题讨论
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            加入漫画爱好者社区，发现志同道合的漫友
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
          {topicItems.map((topic) => (
            <div
              key={topic.id}
              className={`px-5 py-3 rounded-full cursor-pointer transition-all duration-200 text-sm font-medium whitespace-nowrap ${getColorClasses(topic.color)}`}
            >
              <span>{topic.name}</span>
              <span className="ml-2 opacity-70 text-xs">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}